// Règles de CATÉGORIE communes aux formulaires « engin » (création de contrat ET avenants).
// Extraites d'EnginForm pour être appliquées À L'IDENTIQUE partout : la visibilité du genre /
// de la carrosserie était jusqu'ici exprimée de 3 façons divergentes selon les écrans
// (isMoto || TPV / codeCategorie.startsWith('M') / isMoto / inconditionnel).

const codeOf = (categorie) => (categorie?.codeCategorie || categorie || "").toString().trim().toUpperCase();
const nomOf = (categorie) => (categorie?.nom || "").toString().toUpperCase();

/**
 * Catégorie MOTO : 'M' (branche MOTO) ou 'MO' (GUM-MOTO).
 * ⚠ On teste le CODE et non le nom : l'ancien test `nom === 'MOTO'` d'EnginForm ratait
 * les motos GUM (code 'MO', nom « GUM-MOTO ») → genre/carrosserie n'étaient pas proposés.
 */
export const isMotoCategorie = (categorie) => {
    const code = codeOf(categorie);
    return code === "M" || code === "MO";
};

/** Transport Public de Voyageurs (code/nom TPV ou « TRANSPORT », ou usage TPV). */
export const isTpvCategorie = (categorie, usage) => {
    const code = codeOf(categorie);
    const nom = nomOf(categorie);
    const us = (usage || "").toString().toUpperCase();
    return (
        code.includes("TPV") ||
        nom.includes("TPV") ||
        nom.includes("TRANSPORT") ||
        us === "TPV" ||
        us.includes("TRANSPORT")
    );
};

/** Genre & carrosserie sont PROPOSÉS pour les motos ET les TPV. */
export const showGenreCarosserie = (categorie, usage) =>
    isMotoCategorie(categorie) || isTpvCategorie(categorie, usage);

/** Ils ne sont OBLIGATOIRES que pour les motos ('M' / 'MO'). Facultatifs ailleurs (TPV…). */
export const genreCarosserieRequired = (categorie) => isMotoCategorie(categorie);

/** Élément par défaut d'une liste de paramètres (le premier ; l'unique s'il n'y en a qu'un). */
export const defaultLibelle = (list = []) =>
    (Array.isArray(list) && list.length ? list[0]?.libelleParametre : null) ?? null;

/**
 * Rend une valeur COHÉRENTE avec la catégorie : on garde la valeur existante si elle
 * appartient bien à la liste de la catégorie, sinon on retombe sur un élément par défaut
 * de cette liste.
 *
 * Pourquoi : un engin porte des valeurs héritées (saisie ancienne, changement de catégorie,
 * reprise de données). Ex. réel : un contrat affichait « CADRE » en carrosserie et
 * « VELOMOTEUR » en genre — des valeurs MOTO — alors que la catégorie du contrat ne les
 * propose pas. Le Select affichait donc une sélection invalide, non ré-enregistrable.
 *
 * Tant que la liste n'est pas chargée (vide), on ne touche à rien.
 *
 * @param {string} value valeur actuelle de l'engin (genre / carrosserie)
 * @param {Array}  list  liste de la catégorie ([{ libelleParametre }])
 */
export const coerceToCategorie = (value, list = []) => {
    if (!Array.isArray(list) || !list.length) return value ?? null;
    const v = (value || "").toString().trim().toUpperCase();
    const match = list.find(
        (p) => (p?.libelleParametre || "").toString().trim().toUpperCase() === v
    );
    return match ? match.libelleParametre : defaultLibelle(list);
};
